import { QueryClient } from "@tanstack/react-query";
import { KARYAWAN_STAFF_TYPE, UserType } from "shared/types/enum";

// Every list an employee row can appear on, by query-key prefix
// (getAllStaffByBusinessId caches under [staff_type, userParams] with a
// five-minute staleTime; the prefix alone matches every userParams
// variation). The Instruktur / Staf pages both read KARYAWAN_STAFF_TYPE and
// filter by role client-side, so a write that changes an instructor's row
// must refresh that key too, not just [UserType.Instructor] (the schedule
// pickers). A person can hold both employee roles, so all three go together.
export const EMPLOYEE_LIST_KEYS = [
  UserType.Instructor,
  UserType.Staff,
  KARYAWAN_STAFF_TYPE,
] as const;

// Refresh every employee list after a write that changes an employee row:
// a new or edited employee, a role change, deactivation / reactivation,
// a CSV import, or one of the roster-summary writes (working hours, leave,
// assigned classes) that feed the Instruktur list's summary columns.
export const invalidateEmployeeLists = (queryClient: QueryClient) => {
  for (const key of EMPLOYEE_LIST_KEYS) {
    queryClient.invalidateQueries({ queryKey: [key] });
  }
};
